import { gql } from "apollo-boost";

export const CanBuyItem = gql`
  query CanBuyItem($input: UserCoinsCanBuyItemInput!) {
    canBuyItem(input: $input)
  }
`;
